import { Button, Form, Input, Select, Breadcrumb } from "antd";

import { useNavigate, useParams } from "react-router-dom";

import "../styles/globalStyle.css";
import { EditDoctorAction, GetOneDoctorAction } from "../utils/action";
import { Fragment, useEffect, useState } from "react";

const { Option } = Select;

const options = [
  { label: "NEPHROLOGY", value: "NEPHROLOGY" },
  { label: "EHC", value: "EHC" },
  { label: "PLASTIC SURGERY", value: "PLASTIC SURGERY" },
];
const EditDoctor = () => {
  const [doctor, setDoctor] = useState();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { doctorId } = useParams();

  // get the doctor data from the given id from the server
  const getDoctorData = async () => {
    const { data } = await GetOneDoctorAction(doctorId);
    console.log(data.data.doctor);
    setDoctor(data.data.doctor);
    form.setFieldsValue({
      name: data.data.doctor.name,
      email: data.data.doctor.email,
      department: data.data.doctor.department,
    });
  };

  useEffect(() => {
    getDoctorData();
  }, []);

  const handleFormSubmit = (value) => {
    console.log(value);
    const sendDoctorData = async () => {
      const data = await EditDoctorAction(doctorId, value);
      console.log(data);
      if (data.data.success) {
        navigate("/doctors");
      }
    };
    sendDoctorData();
  };
  return (
    <Fragment>
      <Breadcrumb style={{ margin: "20px 0" }}>
        <Breadcrumb.Item key={"/doctors/edit"}>
          {"Doctors/edit"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div
        style={{
          marginTop: "40px",
        }}>
        <Form form={form} onFinish={handleFormSubmit}>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please enter the name" }]}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 8 }}>
            <Input placeholder="Enter Name" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: "Please enter the Email" }]}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 8 }}>
            <Input placeholder="Enter Email " />
          </Form.Item>
          <Form.Item
            label="Department"
            name="department"
            rules={[{ required: true, message: "Please enter the department" }]}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 8 }}>
            <Select
              placeholder="Select department"
              style={{
                width: 200,
              }}
              options={options}>
              {options.map((option) => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 11, span: 8 }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Fragment>
  );
};

export default EditDoctor;
